<template>
    <div>
        <slot :data="data" :setData="changeData" :toggle="toggleValue" :isChosen="valueIsChosen" />

        <div :class="clSub('errors')">
            <div v-for="(error, index) in errors" :class="clSub('error')" :key="index">
                {{ error }}
            </div>
        </div>
    </div>
</template>

<script>
import Base from './Base';

export default {
    extends: Base,
    props: {
        multiple: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        changeData(newData) {
            this.data = newData; 
            this.dataChanged(true);
        },
        toggleValue(key, value = undefined) {
            let data = this.data;

            if(!data && this.multiple) {
                if(value !== undefined) {
                    data = {};
                } else {
                    data = [];
                }
            }

            if(this.multiple) {
                if(Array.isArray(data)) {
                    const currentIndex = data.indexOf(key);

                    if(currentIndex != -1) {
                        data.splice(currentIndex, 1);
                    } else {
                        data.push(key);
                    }
                } else {
                    if(key in data) {
                        delete data[key];
                    } else {
                        data[key] = value;
                    }
                }
            } else {
                data = data == key ? null : key;
            }

            this.changeData(data);
        },
        valueIsChosen(value) {
            if(this.multiple) {
                if(Array.isArray(this.data)) {
                    const index = this.data.indexOf(value);

                    return index != -1 ? index : false;
                } else if(this.data && typeof this.data == 'object') {
                    return Object.keys(this.data).find(k => this.data[k] == value);
                }
            } else {
                return this.data == value;
            }

            return false;
        }
    }
}
</script>